import { AxiosError } from "axios"

export default function retrieveAxiosErr (err: any) {
  let errMsg: string | null = null
  // if (result) {
  //   errMsg = result.data.resultText || errMsg
  // } else if (err.isAxiosError) {
  //   const axiosError = err as AxiosError
  //   errMsg =
  //     axiosError.response?.data?.errors?.title
  //     || axiosError.message
  // }
  if (err instanceof Object) {
    const errData = err?.isAxiosError 
      ? (err as AxiosError<any>).response?.data
      : err

    errMsg = errData?.message
      || errData?.error_description
      || (errData?.errors && Object.values(errData.errors).flatMap(a => a)[0])
      || errData?.error
  } else if (typeof err === 'string') {
    errMsg = err
  }

  errMsg = errMsg ||
    err?.message || 'Unknown error occurred'
  return errMsg as string
}